<template>
  <v-card
    v-if="inPlayEventsMap && Object.keys(inPlayEventsMap).length > 0"
    light
    tile
    flat
    outlined
  >
    <template v-for="(key, i) in ['4', '1', '2', '2378962']">
      <inplay-title
        v-if="inPlayEventsMap[key]"
        :key="'title' + i"
        :category="inPlayEventsMap[key][0].eventType"
        :category-text="inPlayEventsMap[key][0].eventType"
      />
      <template v-for="eventItem in inPlayEventsMap[key]">
        <inplay-odds
          :key="
            eventItem &&
            eventItem.market &&
            eventItem.market.id &&
            'odds' + eventItem.market.id
          "
          :class="{
            'bottom-radius': checkForLastElement(
              inPlayEventsMap[key].indexOf(eventItem),
              inPlayEventsMap[key]
            )
          }"
          :market="eventItem"
          :tv="!!eventItem.hasVideo"
        />
      </template>
    </template>
  </v-card>
</template>
<script>
import { mapState } from 'vuex'
import InplayTitle from '@/components/inplay/InplayTitle'
import InplayOdds from '@/components/inplay/InplayOdds'
export default {
  name: 'Inplay',
  components: { InplayTitle, InplayOdds },
  data() {
    return {
      interval: '',
      inPlayEventsMap: {}
    }
  },
  computed: {
    ...mapState({
      inplayMarkets: (state) => state.inplay.markets,
      balanceSettings: (state) => state.settings.balanceSettings
    })
  },
  watch: {
    inplayMarkets() {
      const eventsMap = {}
      this.inplayMarkets.forEach((e) => {
        const event = e.eventTypeId
        eventsMap[event]
          ? (eventsMap[event] = [...eventsMap[event], e])
          : (eventsMap[event] = [e])
      })
      this.inPlayEventsMap = eventsMap
    }
  },
  created() {
    let userId
    if (this.$auth.loggedIn) {
      userId = this.$auth.user._id
    }
    if (!this.balanceSetting) {
      this.$store.dispatch('settings/balanceSettings')
    }

    try {
      this.interval = setInterval(() => {
        this.$store.dispatch('inplay/get', { userId })
      }, 1000)
    } catch (error) {}
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  methods: {
    checkForLastElement(index, array) {
      return index === array.length - 1
    }
  }
}
</script>
<style lang="scss" scoped>
.item-odds {
  + .item-odds {
    border-top: 1px solid #e0e0e0;
  }
}
.match-card {
  margin-top: 10px !important;
}
.match-card:nth-child(1) {
  margin-top: 0px !important;
}
.inplay-match > .v-sheet {
  background: transparent;
}
.bottom-radius {
  border-bottom-left-radius: 1rem !important;
  border-bottom-right-radius: 1rem !important;
}
</style>
